import styles from "./styles.module.scss";
import primaryComponents from "../../../../primaryComponents";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { useParams } from "react-router-dom";
import { useGetServiceDateAvailablity } from "../../../../../hooks/api/queries";
import { useEffect, useMemo, useState } from "react";
import secondaryComponents from "../../..";
import { DeleteBtnIcon } from "../../../../../assets/svgIcons";
import { useTimeView } from "./useTimeView";
import { toAmPm } from "../../../../../helpers";

export const TimeView = ({
  bookDetails = {},
  setBookDetails = () => {},
  closeModal = () => {},
}) => {
  const { service_id, store_id } = useParams();

  const [queryParams, setQueryParams] = useState({
    store_id,
    date: null,
  });

  const { data: timeDetails = {}, isLoading } = useGetServiceDateAvailablity({
    queryParams,
    service_id,
  });

  useEffect(() => {
    if (bookDetails?.active_booking_date) {
      setQueryParams((prev) => ({
        ...prev,
        date: bookDetails.active_booking_date,
      }));
    }
  }, [bookDetails?.active_booking_date]);

  const currentBooking = useMemo(() => {
    return (
      bookDetails?.bookings?.find(
        (b) => b.date === bookDetails?.active_booking_date,
      ) || null
    );
  }, [bookDetails?.active_booking_date, bookDetails?.bookings]);

  const slotMap = useMemo(() => {
    const map = new Map();
    timeDetails?.slots?.forEach((slot) => {
      map.set(String(slot?.start_time), slot);
    });
    return map;
  }, [timeDetails?.slots]);

  const { removeSlot, updateSlotCount } = useTimeView({
    bookDetails,
    setBookDetails,
  });

  return (
    <>
      <div className={styles.timeContainer}>
        <section className={styles.timeView}>
          <secondaryComponents.LoaderHelper
            isLoading={isLoading}
            classNames="mt-4"
          >
            {bookDetails?.active_booking_date ? (
              <div className={styles.timeContainer}>
                {timeDetails?.slots?.map((slot) => (
                  <span
                    key={slot.start_time}
                    className={`${styles.time} ${
                      slot.status !== "AVAILABLE" ? styles.notAvailable : ""
                    }`}
                    onClick={() =>
                      slot.status === "AVAILABLE" && updateSlotCount(1, slot)
                    }
                  >
                    {toAmPm(slot.start_time)} - {toAmPm(slot.end_time)}
                    <br />
                    <span
                      className={`mt-2 d-block ${
                        slot.remaining_capacity > 0
                          ? "success--text"
                          : "error--text"
                      }`}
                    >
                      ({slot.remaining_capacity} available)
                    </span>
                  </span>
                ))}
              </div>
            ) : (
              <h5 className="text-center mt-5">Select Day to proceed</h5>
            )}
          </secondaryComponents.LoaderHelper>
        </section>

        <section className={styles.slotView}>
          {currentBooking?.time_slots?.map((time_slot) => {
            const currentSlot = slotMap.get(String(time_slot.time));

            if (!currentSlot) return null;

            return (
              <div
                key={`${currentBooking.date}-${time_slot.time}`}
                className={`${globalStyles.cardWithBorder} flex-wrap flex-row align-items-center justify-content-between white`}
              >
                <h5>
                  {toAmPm(time_slot.time)} - {toAmPm(currentSlot?.end_time)}
                </h5>

                <div className="d-flex" style={{ gap: 10 }}>
                  <primaryComponents.Button
                    classNames="btn btn--outline"
                    style={{ height: 40, width: 70 }}
                    onClick={() => updateSlotCount(-1, currentSlot)}
                  >
                    -
                  </primaryComponents.Button>

                  <primaryComponents.CartInputField
                    defaultValue={time_slot.no_of_slot}
                    style={{ height: 40, width: 70 }}
                    updateCart={(val) => updateSlotCount(val, currentSlot)}
                  />

                  <primaryComponents.Button
                    className="btn btn--primary"
                    style={{ height: 40, width: 70 }}
                    onClick={() => updateSlotCount(1, currentSlot)}
                  >
                    +
                  </primaryComponents.Button>

                  <primaryComponents.Button
                    className="btn btn--outline-red"
                    style={{ height: 40, width: 45, padding: 0 }}
                    onClick={() => removeSlot(currentSlot)}
                  >
                    <DeleteBtnIcon />
                  </primaryComponents.Button>
                </div>
              </div>
            );
          })}

          {!currentBooking?.time_slots?.length && (
            <h5 className="text-center mt-5">Please select time slots</h5>
          )}
        </section>
      </div>

      <div className={`${globalStyles.stickyBottomCover} ${styles.bottom}`}>
        <primaryComponents.Button
          classNames="btn btn--primary cover"
          onClick={closeModal}
        >
          Continue
        </primaryComponents.Button>
      </div>
    </>
  );
};
